import script from "./SetupReviewPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupReviewPanel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import Pill from "@/components/catering/Pill.vue";
script.components = Object.assign({}, { Pill }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { Pill }, script.__o.components);}